import type { SupportedRasterFormat } from '@/shared/image/filePreflight'
import type { PhysicalPhotoInspection } from './physicalPhotoSize'

interface WorkerResponse {
  id: number
  result?: PhysicalPhotoInspection
  error?: string
}

let requestId = 0

export function inspectPhysicalPhoto(
  bytes: ArrayBuffer,
  format: SupportedRasterFormat,
  signal: AbortSignal,
): Promise<PhysicalPhotoInspection> {
  return new Promise((resolve, reject) => {
    if (signal.aborted) {
      reject(new DOMException('Aborted', 'AbortError'))
      return
    }
    const id = ++requestId
    const worker = new Worker(new URL('../worker/physicalPhotoSize.worker.ts', import.meta.url), { type: 'module' })
    const cleanup = () => {
      signal.removeEventListener('abort', abort)
      worker.terminate()
    }
    const abort = () => {
      cleanup()
      reject(new DOMException('Aborted', 'AbortError'))
    }
    signal.addEventListener('abort', abort, { once: true })
    worker.onerror = () => {
      cleanup()
      reject(new Error('processing_failed'))
    }
    worker.onmessage = (event: MessageEvent<WorkerResponse>) => {
      if (event.data.id !== id) return
      cleanup()
      if (event.data.result) resolve(event.data.result)
      else reject(new Error(event.data.error ?? 'processing_failed'))
    }
    worker.postMessage({ id, bytes, format }, [bytes])
  })
}
